// Cookie Configuration for PawPrints
// Modify these settings to control cookie behavior across the website

export const COOKIE_CONFIG = {
  // Set to true when you want to show the cookie banner
  enabled: false,
  
  // Cookie settings
  cookieName: 'pawprints_cookie_consent',
  expiryDays: 365,
  domain: window.location.hostname,
  
  // Default preferences (when user hasn't made a choice)
  defaultPreferences: {
    necessary: true,     // Always true, cannot be disabled
    analytics: false,    // Google Analytics, etc.
    marketing: false,    // Marketing pixels, ads
    performance: false   // Performance monitoring
  },
  
  // Analytics configuration (for when analytics are enabled)
  analytics: {
    googleAnalyticsId: '', // Add your GA4 ID here when ready
    enableEnhancedEcommerce: false,
    enableUserIdTracking: false
  },
  
  // Marketing configuration (for when marketing cookies are enabled)
  marketing: {
    facebookPixelId: '',     // Add Facebook Pixel ID when ready
    googleAdsId: '',         // Add Google Ads conversion tracking
    enableSocialWidgets: false // Social media share buttons
  },
  
  // Performance monitoring (for when performance cookies are enabled)
  performance: {
    enableErrorTracking: false,  // Error monitoring services
    enableSpeedTracking: false,  // Page load time tracking
    enableUserExperience: false  // User interaction tracking
  }
};

// Helper functions for cookie management
export const cookieHelpers = {
  // Check if a specific cookie type is enabled
  isEnabled: (cookieType) => {
    const consent = localStorage.getItem(COOKIE_CONFIG.cookieName);
    if (!consent) return false;
    
    try {
      const consentData = JSON.parse(consent);
      return consentData.preferences[cookieType] || false;
    } catch {
      return false;
    }
  },
  
  // Get all current preferences
  getPreferences: () => {
    const consent = localStorage.getItem(COOKIE_CONFIG.cookieName);
    if (!consent) return COOKIE_CONFIG.defaultPreferences;
    
    try {
      const consentData = JSON.parse(consent);
      return consentData.preferences || COOKIE_CONFIG.defaultPreferences;
    } catch {
      return COOKIE_CONFIG.defaultPreferences;
    }
  },
  
  // Clear all cookie preferences (for testing)
  clearPreferences: () => {
    localStorage.removeItem(COOKIE_CONFIG.cookieName);
  },
  
  // Initialize analytics (call this when analytics cookies are accepted)
  initializeAnalytics: () => {
    if (COOKIE_CONFIG.analytics.googleAnalyticsId) {
      // Initialize Google Analytics
      console.log('Analytics initialized:', COOKIE_CONFIG.analytics.googleAnalyticsId);
      // Add actual GA initialization code here
    }
  },
  
  // Initialize marketing tools (call this when marketing cookies are accepted)
  initializeMarketing: () => {
    if (COOKIE_CONFIG.marketing.facebookPixelId) {
      // Initialize Facebook Pixel
      console.log('Facebook Pixel initialized:', COOKIE_CONFIG.marketing.facebookPixelId);
      // Add actual FB Pixel initialization code here
    }
    
    if (COOKIE_CONFIG.marketing.googleAdsId) {
      // Initialize Google Ads
      console.log('Google Ads initialized:', COOKIE_CONFIG.marketing.googleAdsId);
      // Add actual Google Ads initialization code here
    }
  },
  
  // Initialize performance monitoring (call this when performance cookies are accepted)
  initializePerformance: () => {
    if (COOKIE_CONFIG.performance.enableErrorTracking) {
      // Initialize error tracking
      console.log('Error tracking initialized');
      // Add actual error tracking initialization code here
    }
    
    if (COOKIE_CONFIG.performance.enableSpeedTracking) {
      // Initialize speed tracking
      console.log('Speed tracking initialized');
      // Add actual speed tracking initialization code here
    }
  }
};

// Instructions for enabling cookie banner:
// 1. Set COOKIE_CONFIG.enabled = true
// 2. Add your analytics/marketing IDs to the respective sections
// 3. Implement the actual initialization code in the helper functions
// 4. Test the banner functionality
// 5. Update the Cookie Policy page if needed

export default COOKIE_CONFIG;